import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, ContentChild, TemplateRef } from '@angular/core';
import { HeaderComponent } from '@app/header/header.component';

@Component({
  selector: 'app-page',
  standalone: true,
  imports: [CommonModule, HeaderComponent],
  templateUrl: './page.component.html',
  styleUrl: './page.component.scss',
  host: {
    'ngSkipHydration': 'true'
  },
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PageComponent {
  @ContentChild('headerTpl', {static: false, read: TemplateRef})
  public headerTpl: TemplateRef<any>;

  @ContentChild('mainTpl', {static: false, read: TemplateRef})
  public mainTpl: TemplateRef<any>;
}
